// Shared across hook instances (provider and recording button). This lease
// owns startup UI effects only; it says nothing about recorder liveness.
export type RecordingStartEffectsLease = Readonly<{
  token: symbol;
  sessionId: string;
}>;

let currentLease: RecordingStartEffectsLease | null = null;

export function claimRecordingStartEffects(
  sessionId: string
): RecordingStartEffectsLease {
  const lease = Object.freeze({ token: Symbol('recording-start-effects'), sessionId });
  currentLease = lease;
  return lease;
}

// Ordinary Pause/Stop must revoke startup effects before their first await.
// A stale callback for another session cannot revoke the current owner.
export function retireRecordingStartEffects(sessionId: string): void {
  if (currentLease?.sessionId === sessionId) currentLease = null;
}

export function ownsRecordingStartEffects(lease: RecordingStartEffectsLease): boolean {
  return currentLease === lease;
}
